module.exports = __webpack_public_path__ + "img/法雷奥.png";